import { render, staticRenderFns } from "./customer-create-order-form-component.vue?vue&type=template&id=22495b3a&scoped=true"
import script from "./customer-create-order-form-component.vue?vue&type=script&lang=js"
export * from "./customer-create-order-form-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22495b3a",
  null
  
)

export default component.exports